<template>
  <div class="">
    <!-- <div class="home-powered-box">
      <div class="">
        <p>powered by</p>
        <img class="logo dark-logo" src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" height="10"/>
        <img class="logo light-logo" src="@/assets/images/phelcom/eyercloud_logo_white.svg" alt="Eyercloud logo" height="10"/>
        <p class="version">v {{ appVersion }}</p>
      </div>

      <div class="">
        <p>technology by</p>
        <a href="https://phelcom.com/" class="logo" target="_blank" data-test="anchorPhelcomLink">
          <img class="dark-logo" src="@/assets/images/phelcom/phelcom_logo_horizontal_blue.svg" alt="Phelcom logo" height="12"/>
          <img class="light-logo" src="@/assets/images/phelcom/phelcom_logo_horizontal_white.svg" alt="Phelcom logo" height="12"/>
        </a>

        <img class="aws-logo" src="@/assets/images/erjart/logo_aws.svg" alt="Logo AWS" height="12"/>
      </div>
    </div> -->

    <header class="flex-between">
      <div class="">
        <div class="clinic-box">
          <div class="">
            <h1 class="c-pointer" v-if="session.currentClinic" @click="toExam">
              {{ session.currentClinic.name }}
            </h1>

            <button class="btn-icon btn-outline-hover" type="button" name="button" data-test="btnChangeClinic" @click="openChangeOffcanvas">
              <IconChange/>
            </button>
          </div>

          <div class="">
            <p>
              powered by
            </p>
            <img class="logo dark-logo" src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Eyercloud logo" width="52"/>
            <img class="logo light-logo" src="@/assets/images/phelcom/eyercloud_logo_white.svg" alt="Eyercloud logo" width="52"/>
          </div>
        </div>

      </div>
      <div class="search-box" :class="{'open': headerPatientList.length || isExamFilter || showLatestResults}" ref="searchBox" v-if="showSearchBox">
        <div class="form-group" :class="{'is-patient-list': isPatientRoute}">
          <IconSearchFilter/>
          <input class="form-control"
                 type="text"
                 name="search"
                 v-model="searchValue"
                 v-if="!isExamFilter && showSearchBox"
                 :placeholder="isExamFilter ? $t('patientSearch.searchPatientExam') : (isPatientRoute ? $t('patientSearch.searchInList') : $t('patientSearch.search'))"
                 @keyup="doSearch($event)"
                 @keypress.enter.prevent.stop="showAllSearchedPatients"
                 @click="handleInputClick"
                 @close="isLoadingPatients = false"
                 @keydown.left.stop="void 0"
                 @keydown.right.stop="void 0"
                 :disabled="isLoadingPatients"/>

          <p class="no-margin" v-else>{{ $t('exam.filterExams') }}</p>

          <IconClose class="clear-search icon-close" v-if="searchValue" @click="clearSearchValue"/>
          <div class="search-box-actions" v-if="isExamRoute">
            <IconFilter v-if="!isExamFilter" @click="toggleExamFilter"/>
            <IconClose class="icon-close" v-else @click="toggleExamFilter"/>
          </div>

          <button class="btn btn-outline-secondary" type="button" name="button" v-if="!isPatientRoute" @click="toPatient">
            {{ $t('patientSearch.allPatients') }}
          </button>
        </div>

        <div class="list-group-box" v-if="!isPatientRoute && (headerPatientList.length || showLatestResults)">
          <div class="" v-if="showLatestResults">
            <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastSevenDays()">
              {{ $t('patientSearch.lastSevenDays') }}
            </button>

            <!-- <button class="btn btn-square" type="button" name="button" @click="doFilterExamListByEyerMaps()">
              EyerMaps
            </button> -->

            <ul class="last-search-list">
              <li>
                <IconClock/>
                <p>Aguiar de Souza</p>
              </li>
              <li>
                <IconClock/>
                <p>Maria</p>
              </li>
              <li>
                <IconClock/>
                <p>Bruno</p>
              </li>
              <li>
                <IconClock/>
                <p>Ricardo</p>
              </li>
              <li>
                <IconClock/>
                <p>Augusto</p>
              </li>
            </ul>
          </div>

          <div class="patient-list-box" v-if="headerPatientList.length">
            <ul class="list-group scrollbar">
              <li class="list-group-item" v-for="(item, index) in headerPatientList" :key="index" @click="doFilterExamListByPatientID(item)">
                <IconPatientsSearch/>

                <div class="">
                  <p>{{ item.fullName }}</p>

                  <div class="id-box">
                    <div class="icon-sub"></div>
                    <span>{{ $utils.getFormattedPatientDocumentWithSearchMatch(item, searchValue, $i18n) }}</span>
                  </div>
                </div>

                <small>{{ formatDate(item.lastExamDate) }}</small>

                <button class="btn btn-outline-secondary" type="button" name="button" @click.stop="openPatientDetails(item)">
                  {{ $t('patientSearch.openPatient') }}
                </button>
              </li>
            </ul>

            <div class="search-all-box" @click="showAllSearchedPatients">
              <IconSearchFilter/>

              <p>{{ $t('patientSearch.searchAll') }}<strong>{{ searchValue }}</strong></p>

              <small>{{ $t('patientSearch.pressEnter') }}</small>
            </div>
          </div>

        </div>

        <div class="exam-filter-box" v-if="isExamFilter" id="examFilterBox">
          <ExamFilter v-if="isExamRoute" @close="toggleExamFilter"
                      :currentProperties="examFilterStore.filter.filter.properties"
                      :currentDates="{ startDate: examFilterStore.filter.filter.startDate, endDate: examFilterStore.filter.filter.endDate }"/>
        </div>
      </div>

      <div class="">
        <MenuStorageBar/>
        <!-- <MenuUsageBar v-else/> -->

        <MenuProfile/>

        <a class="btn btn-outline-secondary" :href="helpcenterUrl" target="_blank">{{ $t('menu.help') }}</a>

        <button class="btn btn-icon btn-outline-hover" type="button" name="button" @click.prevent="toggleTheme">
          <IconMoon/>
        </button>

        <button class="btn btn-icon btn-outline-hover" type="button" name="button" @click="toSettings()">
          <IconSettings class="icon-settings"/>
        </button>
      </div>
    </header>

    <div class="header-filter-box" v-show="hasFilterItems && isExamRoute && !isSmallScreen">
      <p>{{ $t('patientSearch.searchingFor') }}</p>

      <span id="tag_patient" data-value="patient" class="tag2 alert" v-if="currentFilter.patientID">
        <span>{{ currentFilter.patientFullName }}</span>
        <a href="#" @click="clearFilteredList('name')">
          <IconCross/>
        </a>
      </span>

      <span id="tag_date" data-value="date" class="tag2 alert" v-if="currentFilter.startDate || currentFilter.endDate">
        <span>{{ `${currentFilter.startDate} ${$t('until')} ${currentFilter.endDate}` }}</span>
        <a href="#" @click="clearFilteredList('date')">
          <IconCross/>
        </a>
      </span>

      <template v-for="(item, key) in currentFilter.properties" :key="key">
        <span :id="`tag_${key}`" :data-value="key" class="tag2 alert" v-if="item">
          <span>{{ $t(`patientSearch.${key}`) }}</span>
          <a href="#" @click="clearFilteredList(key)">
            <IconCross/>
          </a>
        </span>
      </template>

      <button class="btn btn-outline-secondary" type="button" name="button" @click="clearFilteredList('all')">{{ $t('patientSearch.cleanFilters') }}</button>
    </div>

    <teleport to="body">
      <ClinicChangeOffcanvas v-if="!isSmallScreen" :offcanvas_id="'ClinicChangeOffcanvas'" ref="clinicChangeOffcanvas"/>
      <PatientListSearchedOffcanvas :offcanvas_id="'PatientListSearchedHeaderOffcanvas'" ref="patientListSearchedHeaderOffcanvas" @patient-selected="doFilterExamListByPatientID"/>
    </teleport>
  </div>
</template>

<style src="./HomeHeader.scss" lang="scss" scoped></style>
<script src="./HomeHeader.js"></script>
